import { Layout } from 'antd';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { LOGO } from '../../constants/CONSTANTS';
import { getAllowedURLS } from './DashboardLayout';

type Props = {
  children: React.ReactNode;
};
const { Content } = Layout;
const DashboardLayout = (props: Props) => {
  const location = useLocation();
  const { user } = useSelector((state: AppState) => ({
    user: state.user,
  }));
  const allowed = !!getAllowedURLS(user.role, user.team).find(
    urlPath => urlPath === location.pathname
  );

  return (
    <Layout>
      <StyledContentLayout>
        <StyledHeader>
          <div className="logo">
            <Link to="/">
              <img style={{ height: 25 }} src={LOGO} alt="main-logo" />
            </Link>
          </div>
        </StyledHeader>
        <Content style={{ padding: 20, overflowY: 'auto' }}>
          {allowed ? props.children : 'not allowed'}
        </Content>
      </StyledContentLayout>
    </Layout>
  );
};
const StyledHeader = styled.div`
  background: #f1f1f1;
  border-bottom: 1px solid #e5e5e5;
  height: auto;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;

  .menu-list {
    display: flex;
    align-items: center;
  }
`;
const StyledContentLayout = styled(Layout)`
  height: 100vh;
  overflow: hidden;
  .ant-select-arrow {
    // margin-top: -20px;
  }
`;

export default DashboardLayout;
